<footer class="footer" [style.background-color]="backGroundColor">
  <div class="container" style="display: flex; justify-content: center">
    <ul class="footer__menu-list">
      <li style="font-size: 11px" *ngFor="let item of footerOptions; let indexOfElement = index">
        <a [style.color]="fontColor" target="_blank" [href]="item.routerLink">{{ item?.name }}</a>
        <span [style.color]="fontColor" class="pipe" *ngIf="indexOfElement !== footerOptions.length - 1">|</span>
      </li>
    </ul>
  </div>
</footer>
